export default [
  {
    path: '/admin/defines/features',
    name: 'Features',
    component: () => import('@/views/Admin/Defines/Features/Index.vue'),
    meta: {
      pageTitle: 'Özellikler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/features/add',
    name: 'FeatureAdd',
    component: () => import('@/views/Admin/Defines/Features/Add.vue'),
    meta: {
      pageTitle: 'Özellikler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/features',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/features/edit/:id',
    name: 'FeatureEdit',
    component: () => import('@/views/Admin/Defines/Features/Edit.vue'),
    meta: {
      pageTitle: 'Özellikler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/features',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
